import DispatchConstants from 'app/shared/constants/DispatchConstants';

const initState = () => ({
    testExperiments: [],
});

const reducer = (state = initState(), action) => {
    const { type, payload } = action;
    switch (type) {
        case DispatchConstants.ENROLL_AB_TEST_EXPERIMENT:
            return {
                ...state,
                testExperiments: state.testExperiments.concat(payload),
            };
        default:
    }
    return state;
};

export default reducer;
